import './Status404.sass'

import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

export const Status404 = props => {
  const { t } = props

  return (
    <div className='status-404'>
      {t('message_404')  }
    </div>
  )
}

Status404.propTypes = {
  t: PropTypes.func
}

export default withTranslation('global')(Status404)
